var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticStyle:{"height":"500px"},attrs:{"align":"center"}},[_c('v-col',{staticClass:"text-center"},[_c('span',{staticClass:"text-h5 font-weight-light"},[_vm._v("Erro 404 | Página não encontrada")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }